import { useCallback } from 'react';

export const useEmptyState = () => {
  const handleActionClick = useCallback((onClick: () => void) => {
    try {
      onClick();
    } catch (error) {
      console.error('Error executing empty state action:', error);
    }
  }, []);

  return {
    handleActionClick,
  };
};
